import { SignInPage } from '@backstage/core-components';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import {
  createFrontendModule,
  useTranslationRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import type { ComponentProps } from 'react';
import { appTranslationRef } from './translations/app';

function GitHubSignInPage(
  props: Pick<ComponentProps<typeof SignInPage>, 'onSignInSuccess'>,
) {
  const { t } = useTranslationRef(appTranslationRef);

  return (
    <SignInPage
      {...props}
      provider={{
        id: 'github',
        title: 'GitHub',
        message: t('signInPage.githubMessage'),
        apiRef: githubAuthApiRef,
      }}
      auto
    />
  );
}

export const appModuleSignInPage = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => <GitHubSignInPage {...props} />,
      },
    }),
  ],
});
